import { render, staticRenderFns } from "./report-pdf-page.vue?vue&type=template&id=48bf7c3c&scoped=true"
import script from "./report-pdf-page.vue?vue&type=script&lang=js"
export * from "./report-pdf-page.vue?vue&type=script&lang=js"
import style0 from "./report-pdf-page.vue?vue&type=style&index=0&id=48bf7c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf7c3c",
  null
  
)

export default component.exports